// Rebook variant swap (spec docs/superpowers/specs/2026-09-01-kiosk-rebook-variant-swap-design.md).
// Families come from GET /api/kiosk/rebook-variants — per-center IDs for the
// Brazilian first-time / standard / upkeep variants. Pure functions; the
// component supplies the date context.

// Mirrors KioskCheckOut's upkeepCutoffDate: cutoff = now + maxWeeks*7 days at
// end-of-day; the candidate day is compared at noon so timezones can't flip it.
// null/undefined date = "no day picked yet" → treated as within (same default
// the discount logic uses).
export function isWithinUpkeepWindow(isoDate, now, maxWeeks) {
  if (!isoDate) return true;
  const cutoff = new Date(now);
  cutoff.setDate(cutoff.getDate() + maxWeeks * 7);
  cutoff.setHours(23, 59, 59, 999);
  return new Date(isoDate + 'T12:00:00') <= cutoff;
}

// Returns the service to actually show/price/book for a cart entry. Identity
// (===) when no swap applies, so callers can cheaply detect "unchanged".
// A swapped result carries variantOf = the original service id.
export function resolveRebookService(svc, withinUpkeep, families) {
  if (!svc || !Array.isArray(families) || families.length === 0) return svc;
  const fam = families.find((f) => (f.memberIds || []).includes(svc.id));
  if (!fam) return svc;
  const target = withinUpkeep ? fam.upkeep : fam.standard;
  if (!target || !target.id || target.id === svc.id) return svc;
  return { ...svc, id: target.id, name: target.name, price: target.price, duration: target.duration, variantOf: svc.id };
}
